module.exports = require("webpack/hot/poll");